import React from 'react';

function dispatchEvent(eventName) {
  // Dispatch event to re-attach orbit functionality.
  if (typeof document !== 'undefined') {
    let event;
    if (typeof (Event) === 'function') {
      event = new Event(eventName);
    } else {
      event = document.createEvent('Event');
      event.initEvent(eventName, true, true);
    }
    document.dispatchEvent(event);
  }
}

export default dispatchEvent;
